import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { observable } from 'mobx';
import PhoneCodeInputStore from '@src/business-components/phone-code-input/store';
import Toast from '@src/components/toast';
import { getParameterByNames } from '@src/utils/common-util';
import { noop } from '@src/utils/common-util';
import redirectToMiniprogram from '@src/utils/h5-redirect-to-miniprogram';
import { MINI_PROGRAM_CONFIG } from '@src/constants/business';
import $$tracker from '@src/tracker';
import { useMount } from 'ahooks';
class PhoneAppointmentModalStore extends BaseModalStore {
  deviceList = [
    {
      label: '安卓',
      value: 'Android'
    },
    {
      label: '苹果',
      value: 'iOS'
    },
    {
      label: '电脑',
      value: 'PC'
    },
    {
      label: '鸿蒙',
      value: 'Harmony'
    }
  ];

  phoneCodeInputStore = new PhoneCodeInputStore({
    sendCodeAsync: params => this.sendCodeAsync(params)
  });

  generateDeviceId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  /**
   * 预约成功回调
   */
  onSuccess = noop;

  @observable isAgree = false;
  // @observable deviceType = this.deviceList[0].value;
  @observable deviceType = [];

  @observable device_id = '';

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  checkAgree() {
    this.isAgree = !this.isAgree;
  }

  // selectDeviceType(deviceType) {
  //   this.deviceType = deviceType;
  // }
  selectDeviceType(deviceType) {
    if (this.deviceType.includes(deviceType)) {
      // 已选中则移除
      this.deviceType = this.deviceType.filter(item => item !== deviceType);
    } else {
      // 未选中则添加
      this.deviceType = [...this.deviceType, deviceType];
    }
  }

  sendCodeAsync = async params => {
    return this.$ztService.getPhoneCode(params);
  };

  getOsInfo = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('Windows') !== -1) return 'Windows';
    if (userAgent.indexOf('Mac OS') !== -1) return 'MacOS';
    if (userAgent.indexOf('Android') !== -1) return 'Android';
    if (userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1) return 'iOS';
    if (userAgent.indexOf('HarmonyOS') !== -1 || userAgent.indexOf('HUAWEI') !== -1) return '楦胯挋';
    return 'Other';
  };

  appointment() {
    if (!this.phoneCodeInputStore.phoneInputStore.value) {
      Toast.fail('请输入手机号');
      return;
    }
    // 正则校验手机号
    const phoneRegex = /^1[3456789]\d{9}$/;
    if (!phoneRegex.test(this.phoneCodeInputStore.phoneInputStore.value)) {
      Toast.fail('请输入正确的手机号');
      return;
    }
    if (!this.phoneCodeInputStore.smsInputStore.value) {
      Toast.fail('请输入验证码');
      return;
    }
    if (!this.isAgree) {
      Toast.fail('请先选择并同意协议');
      return;
    }
    // if (!this.deviceType) {
    //   Toast.fail('请选择预约渠道');
    //   return;
    // }
    if (this.deviceType.length === 0) {
      Toast.fail('请选择预约渠道');
      return;
    }
    const params = {
      phone: this.phoneCodeInputStore.phoneInputStore.value,
      code: this.phoneCodeInputStore.smsInputStore.value,
      operate_from: 'gw_mo',
      // platform: this.deviceType,
      platform: this.deviceType.join(','),
      device_id: this.device_id,
      ua_os: this.getOsInfo(),
      utm_source: getParameterByNames('utm_source')
    };
    this.$ztService
      .subscribe(params)
      .then(res => {
        $$tracker.clickGoReserve(this.deviceType.join(','), 'success', '预约成功');
        Toast.success('预约成功');
        this.onClickClose();
        this.onSuccess();
        this.getConfigAsync && this.getConfigAsync();
      })
      .catch(err => {
        if (err?.serviceResponse?.message) {
          Toast.info(err?.serviceResponse?.message);
        }
        $$tracker.clickGoReserve(this.deviceType.join(','), 'fail', err?.serviceResponse?.message);
      });
  }

  appointmentByMiniprogram = () => {
    redirectToMiniprogram({ ...MINI_PROGRAM_CONFIG });
  };

  use() {
    super.use();
    useMount(() => {
      this.device_id = localStorage.getItem('device_id') || this.generateDeviceId();
      localStorage.setItem('device_id', this.device_id);
    });
  }
}

export default PhoneAppointmentModalStore;
